import axios from 'axios';

const setupDemo = params => {
  return axios.post('converse/demo', params);
};

export { setupDemo };
